import React, { useState, useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { TableSortLabel, Table, TableBody, TableHead, TableRow, TableCell, Checkbox, Button, IconButton, Grid, InputBase, MenuItem, FormControl, InputLabel, Select } from '@mui/material'
import { green, blue } from '@mui/material/colors';
import { formArrayDelete, formChange, formArrayAdd, formSubmitAPI, formChangeAsObj, formObjAdd, formObjDelete } from '../../reducers/form';
import DeleteIcon from '@mui/icons-material/Clear'
import { addGroupMaterial } from '../../api/estimate'
import { deleteRowsFormTable } from '../../reducers/formTable';
import DivideMaterial from './DivideMaterial';
import ReplayIcon from '@mui/icons-material/Replay'
import { makeStyles } from '@mui/styles';
import AutocompliteMUI from 'src/components/AutocompliteMUI';
import { tableEstimateHead } from './estimate.const';

const directionSortConst = {
  ASC: 'asc',
  DESC: 'desc',
};
function stableSort(array, objs, orderBy, order) {
  const stabilizedThis = array.map(key => ([key, String(objs[key][orderBy])]));
  const ord = order === directionSortConst.DESC ? 1 : -1
  stabilizedThis.sort((a, b) => {
    return ord * a[1].localeCompare(b[1], undefined, { numeric: true, sensitivity: 'base' })
  });
  return stabilizedThis.map(el => el[0]);
}
const RowMemo = React.memo(Row)
function EstimateTable({ idProject, reloadWhenAddToGroup, loadEstimate, formName }) {
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('name')
  const [find, setFind] = useState('')
  const [typeFind, setTypeFind] = useState('')
  const dispatch = useDispatch()
  const selectedEstimate = useSelector(state => state.form[formName]?.values.selectedEstimate || [])
  const allIds = useSelector(state => state.formTable[formName]?.allIds || [])
  const byId = useSelector(state => state.formTable[formName]?.byId || {})

  const filteredIds = useMemo(() => {
    const lowerFind = find.toLocaleLowerCase()

    return allIds.filter(v => {
      const item = byId[v]
      if (!item) return false

      const matchFind = find === '' || item.finder.includes(lowerFind)
      const matchType = typeFind === '' || item.type === typeFind

      return matchFind && matchType
    })
  }, [allIds, byId, find, typeFind])

  const arrSorted = useMemo(
    () => stableSort(filteredIds, byId, orderBy, order),
    [filteredIds, byId, orderBy, order]
  )
  const handleClickAll = () => {
    if (selectedEstimate.length === arrSorted.length) {
      dispatch(formChange([], { field: 'selectedEstimate', name: formName }))
    }
    else {
      dispatch(formChange(arrSorted, { field: 'selectedEstimate', name: formName }))
    }
  }
  const handleRequestSort = (event, property) => {
    let orderNew = 'desc';
    if (orderBy === property && order === 'desc') {
      orderNew = 'asc';
    }
    setOrder(orderNew)
    setOrderBy(property)
  };
  const handleFind = (value) => {
    setFind(value)
  }
  const handleChangeFindType = useCallback((find) => {
    setTypeFind(find);
    dispatch(formChange([], { field: 'selectedEstimate', name: formName }))
  }, [dispatch, formName])
  return (<React.Fragment>
    <Move
      formName={formName}
      idProject={idProject}
      find={find}
      handleFind={handleFind}
      reload={loadEstimate}
      reloadWhenAddToGroup={reloadWhenAddToGroup}
      typeFind={typeFind}
      setTypeFind={handleChangeFindType}
    />
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              checked={selectedEstimate.length === arrSorted.length}
              onClick={() => handleClickAll()}
            />
          </TableCell>
          {tableEstimateHead.map(obj => {
            const align = obj.align || 'inherit'
            return (<TableCell
              key={obj.id}
              align={align}
              sortDirection={orderBy === obj.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === obj.id}
                direction={order}
                onClick={(e) => handleRequestSort(e, obj.id)}
              >
                {obj.name}
              </TableSortLabel>
            </TableCell>);
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        {arrSorted.map(id => <RowMemo key={id} id={id} formName={formName} />)}
      </TableBody>
    </Table>
  </React.Fragment>)
}
export default React.memo(EstimateTable)
const useStyles = makeStyles((theme) => ({
  rowDate: {
    "&:hover": { backgroundColor: theme.palette.action.hover }
  },
  cellMaterial: {
    color: green[500]
  },
  cellWork: {
    color: blue[500]
  }
}));
function Row({ id, formName }) {
  const classes = useStyles();
  const dispatch = useDispatch()
  const obj = useSelector(state => state.formTable[formName].byId[id] || {})
  const selected = useSelector(state => state.form[formName]?.values?.selectedEstimate?.indexOf(id) !== -1)
  const name = 'EstimateList'
  const metaArray = { field: 'selectedEstimate', name }
  const metaObj = { id, field: 'selectedEstimateById', name }
  const selectMaterial = () => {
    if (selected) {
      dispatch(formArrayDelete(id, metaArray))
      dispatch(formObjDelete(metaObj))
    }
    else {
      dispatch(formArrayAdd(id, metaArray))
      dispatch(formObjAdd(obj, metaObj))
    }
  }
  return (
    <TableRow role="checkbox" onClick={selectMaterial} className={classes.rowDate}>
      <TableCell padding="checkbox">
        <Checkbox checked={selected} />
      </TableCell>
      {tableEstimateHead.map(e => {
        if (e.id === 'type') {
          if (obj[e.id] === 'material') {
            return <TableCell className={classes.cellMaterial}>М</TableCell>
          }
          return <TableCell className={classes.cellWork}>Р</TableCell>
        }
        return <TableCell key={e.id} align={e.align}>{obj[e.id]}</TableCell>
      })}
    </TableRow>
  );
}
function ButtonDivider() {
  const style = {
    borderLeft: '2px solid #9391a22e',
    height: '32px',
    verticalAlign: 'middle',
    display: 'inline-block',
  }
  return <div style={style} />
}


function Move({ find, handleFind, reload, formName, idProject, reloadWhenAddToGroup, typeFind, setTypeFind }) {
  const dispatch = useDispatch()
  const groupArr = useSelector(state => state.autocomplite?.group?.arr || [])
  const selectedEstimate = useSelector(state => state.form[formName]?.values.selectedEstimate || [])
  const selectedGroup = useSelector(state => state.form[formName]?.values.selectedGroup)
  const summEstimate = useSelector(state => state.form[formName]?.values.summEstimate)
  const byId = useSelector(state => state.formTable[formName]?.byId || {})
  const moveToGroup = () => {
    let summ = 0;
    const arr = selectedEstimate.map(id => {
      const obj = byId[id]
      summ += obj.summ
      return {
        id: obj.id,
        count: obj.count,
        type: obj.type,
        number: Number(obj.number) || ''
      }
    })
    //@ts-ignore
    dispatch(formSubmitAPI({
      props: {
        arr: arr
      },
      url: addGroupMaterial.path({ idProject: idProject, id: selectedGroup }),
      method: addGroupMaterial.type,
      endFunc: (res) => {
        reloadWhenAddToGroup()
        dispatch(formChangeAsObj({
          selectedEstimate: [],
          summEstimate: summEstimate - summ
        }, { name: formName }))
        dispatch(deleteRowsFormTable(selectedEstimate, { name: formName, }))
      }
    }, formName))
  }
  const changeGroup = (e) => dispatch(formChange(e.value, { field: 'selectedGroup', name: formName }))
  const selectedValue = groupArr.find(o => o.value === selectedGroup);
  return (
    <React.Fragment>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-end"
        spacing={2}
      >
        <Grid item>
          <IconButton size="small" color='primary' onClick={() => reload()}>
            <ReplayIcon />
          </IconButton>
        </Grid>
        <Grid item ><ButtonDivider /></Grid>
        <Grid item><InputBase
          onChange={(e) => handleFind(e.target.value)}
          placeholder={'Найти'}
          value={find}
          fullWidth
          endAdornment={<IconButton size="small" onClick={() => handleFind('')}> <DeleteIcon /> </IconButton>}
        /></Grid>
        <Grid item xs={3} >
          <FormControl variant="standard" fullWidth>
            <InputLabel id="type-find-select-label">Тип</InputLabel>
            <Select
              labelId="type-find-select-label"
              id="type-find-select"
              value={typeFind}
              onChange={(e) => setTypeFind(e.target.value)}
              label="Тип"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value='material'>Материал</MenuItem>
              <MenuItem value='work'>Работа</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item ><ButtonDivider /></Grid>
        <Grid item >
          <DivideMaterial formName={formName} />
        </Grid>
        <Grid item ><ButtonDivider /></Grid>
        <Grid item xs={3}>
          <AutocompliteMUI
            options={groupArr}
            action={changeGroup}
            placeHolder='Группа'
            value={selectedValue}
            autocompleteProps={{
              disableClearable: true,
            }}
          />
        </Grid>
        <Grid item >
          <Button disabled={!selectedGroup} color="primary" onClick={() => moveToGroup()}>Переместить</Button>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}